/* Equipe cart goals: progress bar in the cart drawer + cart page, card-only notice under 500,
   and an offer box under the add-to-cart button on product pages. Replaces the BOGOS app. */
(function () {
  var AR = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var GOALS = [
    { at: 500, en: 'Cash on delivery', ar: 'الدفع عند الاستلام', icon: 'cod' },
    { at: 3000, en: 'Free shipping', ar: 'شحن مجاني', icon: 'ship' },
    { at: 4000, en: '10% off', ar: 'خصم 10%', icon: 'pct' },
    { at: 8000, en: '15% off', ar: 'خصم 15%', icon: 'pct' }
  ];
  var ICONS = {
    cod: '<path d="M3 7h18v10H3z M7 12h.01 M12 10a2 2 0 1 0 0 4a2 2 0 0 0 0-4 M17 12h.01"/>',
    ship: '<path d="M3 6h11v9H3z M14 9h4l3 3v3h-7z M7 18a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3 M17 18a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    pct: '<path d="M19 5L5 19 M7 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4 M17 19a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    ok: '<path d="M5 12l5 5L19 7"/>'
  };
  function icon(n) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + ICONS[n] + '</svg>'; }
  function digits(s) { return s; }
  function money(n) {
    var v = Math.ceil(n).toLocaleString('en-US');
    return AR ? digits(v) + ' جنيه' : 'EGP ' + v;
  }
  function t(en, ar) { return AR ? ar : en; }

  var css = document.createElement('style');
  css.textContent =
    '.eq-goals{--eq:#ff5500;--eqd:#111;margin:12px 16px 4px;padding:14px 14px 12px;background:#fff;border:1px solid rgba(17,17,17,.12);font-size:13px;color:var(--eqd)}' +
    '.eq-goals__msg{margin:0 0 4px;text-align:center;font-weight:800;font-size:14px}.eq-goals__msg b{color:var(--eq)}' +
    '.eq-goals__chip{display:block;margin:0 auto 12px;width:fit-content;padding:3px 10px;background:#e9f9ee;color:#137a3a;font-weight:700;font-size:12px}' +
    '.eq-goals__note{margin:10px 0 0;padding:8px 10px;background:#fff4ec;border-inline-start:3px solid var(--eq);font-size:12px;line-height:1.5}' +
    '.eq-goals__track{position:relative;height:4px;background:#e6e6e6;margin:30px 12px 10px}' +
    '.eq-goals__fill{position:absolute;inset-block:0;inset-inline-start:0;background:var(--eq);transition:width .4s}' +
    '.eq-goals__pt{position:absolute;top:50%;transform:translate(-50%,-50%);width:26px;height:26px;display:flex;align-items:center;justify-content:center;background:#fff;border:2px solid #d0d0d0;color:#9a9a9a}' +
    '[dir=rtl] .eq-goals__pt,.eq-goals[dir=rtl] .eq-goals__pt{transform:translate(50%,-50%)}' +
    '.eq-goals__pt svg{width:14px;height:14px}.eq-goals__pt.is-on{background:var(--eq);border-color:var(--eq);color:#fff}' +
    '.eq-goals__lab{position:absolute;bottom:22px;white-space:nowrap;font-size:11px;font-weight:700;line-height:1.2;text-align:center;color:#555}' +
    '.eq-goals__lab small{display:block;font-weight:500;color:#888}' +
    '.eq-offer{margin:14px 0;border:1px solid rgba(17,17,17,.12);background:#fff;color:#111;font-size:14px}' +
    '.eq-offer__head{padding:12px 14px;background:#111;color:#fff;font-weight:800}.eq-offer__head span{color:#ff5500}' +
    '.eq-offer__row{display:flex;gap:10px;align-items:center;padding:10px 14px;border-top:1px solid rgba(17,17,17,.08)}' +
    '.eq-toast{position:fixed;z-index:2147483000;inset-inline:16px;bottom:16px;max-width:380px;margin-inline-start:auto;background:#111;color:#fff;padding:14px 16px;box-shadow:0 12px 30px rgba(0,0,0,.25);transform:translateY(140%);transition:transform .35s;cursor:pointer;font-size:14px}' +
    '.eq-toast.is-on{transform:none}.eq-toast__t{margin:0 0 4px;font-weight:800;display:flex;gap:8px;align-items:center}.eq-toast__t svg{width:18px;height:18px;color:#ff5500;flex:none}' +
    '.eq-toast__s{margin:0 0 10px;color:rgba(255,255,255,.75);font-size:13px}.eq-toast__s b{color:#ff5500}' +
    '.eq-toast__bar{height:4px;background:rgba(255,255,255,.18)}.eq-toast__bar i{display:block;height:100%;background:#ff5500;transition:width .5s}' +
    '.eq-card-btn{background:#111!important;border-color:#111!important;color:#fff!important}' +
    '.eq-offer__row svg{width:18px;height:18px;flex:none;color:#ff5500}.eq-offer__row b{font-weight:800}';
  document.head.appendChild(css);

  function barHTML(sub) {
    var next = null, done = [];
    GOALS.forEach(function (g) { if (sub >= g.at) done.push(g); else if (!next) next = g; });
    var msg, chip = '';
    if (next) msg = t('Add <b>' + money(next.at - sub) + '</b> to get ' + next.en, 'أضف <b>' + money(next.at - sub) + '</b> لتحصل على ' + next.ar);
    else msg = t('You unlocked every offer', 'حصلت على جميع العروض');
    if (done.length) { var last = done[done.length - 1]; chip = '<span class="eq-goals__chip">' + t(last.en + ' unlocked', last.ar + ' مُفعّل') + ' ✓</span>'; }
    else chip = '<span class="eq-goals__chip" style="background:#f3f3f3;color:#555">' + t('Start adding to unlock offers', 'أضف منتجات لتفعيل العروض') + '</span>';
    // points sit at the middle of equal slots so labels never overflow the edges
    var n = GOALS.length, P = function (i) { return (i + 0.5) / n * 100; }, pct = 100;
    for (var i = 0; i < n; i++) {
      if (sub >= GOALS[i].at) continue;
      var from = i === 0 ? 0 : GOALS[i - 1].at, a = i === 0 ? 0 : P(i - 1);
      pct = a + (sub - from) / (GOALS[i].at - from) * (P(i) - a); break;
    }
    var pts = GOALS.map(function (g, i) {
      var pos = P(i), on = sub >= g.at;
      var side = AR ? 'right' : 'left';
      var lab = '<span class="eq-goals__lab" style="' + side + ':' + pos + '%;transform:translateX(' + (AR ? '50%' : '-50%') + ')">' + (AR ? g.ar : g.en) + '<small>' + money(g.at) + '+</small></span>';
      return lab + '<span class="eq-goals__pt' + (on ? ' is-on' : '') + '" style="' + side + ':' + pos + '%">' + icon(on ? 'ok' : g.icon) + '</span>';
    }).join('');
    var note = sub > 0 && sub < 500 ? '<p class="eq-goals__note">' + t('Orders under EGP 500 are paid by card only. Add ' + money(500 - sub) + ' to pay cash on delivery.', 'الطلبات الأقل من 500 جنيه تُدفع بالبطاقة فقط. أضف ' + money(500 - sub) + ' لتتمكن من الدفع عند الاستلام.') + '</p>' : '';
    return '<p class="eq-goals__msg">' + msg + '</p>' + chip +
      '<div class="eq-goals__track"><span class="eq-goals__fill" style="width:' + pct + '%"></span>' + pts + '</div>' + note;
  }

  var subtotal = null;
  function render() {
    if (subtotal === null) return;
    var hosts = document.querySelectorAll('.cart-drawer__content, .cart-page .cart-items-component, #MainContent[data-template="cart"] .cart-items-component');
    hosts.forEach(function (h) {
      if (!h.querySelector('.cart-items__table-row, .cart-items__table, .cart-items')) { var old = h.querySelector('.eq-goals'); if (old) old.remove(); return; }
      var box = h.querySelector(':scope > .eq-goals');
      var html = barHTML(subtotal / 100);
      if (!box) { box = document.createElement('div'); box.className = 'eq-goals'; box.dir = AR ? 'rtl' : 'ltr'; h.prepend(box); }
      if (box._h !== html) { box._h = html; box.innerHTML = html; }
    });
  }
  function checkoutBtn() {
    if (subtotal === null) return;
    // checkout button: under 500 it says "pay by card" and turns dark
    var low = subtotal > 0 && subtotal / 100 < 500;
    document.querySelectorAll('button[name="checkout"], #checkout, a[href*="/checkout"]').forEach(function (b) {
      if (b.dataset.eqOrig === undefined) b.dataset.eqOrig = b.innerHTML;
      var want = low ? t('Pay by card', 'الدفع بالبطاقة') : b.dataset.eqOrig;
      if (b._eq !== low) { b._eq = low; b.innerHTML = want; b.classList.toggle('eq-card-btn', low); }
    });
  }

  // small toast after each cart change, because the drawer does not open by itself
  var prev = null, userChange = false, toastEl = null, hideT = null;
  function toast(before, after) {
    var b = before / 100, a = after / 100, crossed = null, next = null;
    GOALS.forEach(function (g) { if (b < g.at && a >= g.at) crossed = g; if (!next && a < g.at) next = g; });
    var CROSS = {
      500: ['Cash on delivery unlocked', 'أصبح الدفع عند الاستلام متاحًا لطلبك'],
      3000: ['Free shipping unlocked', 'حصلت على شحن مجاني'],
      4000: ['You got 10% off your order', 'حصلت على خصم 10% على طلبك'],
      8000: ['You got 15% off your order', 'حصلت على خصم 15% على طلبك']
    };
    var title = crossed ? t(CROSS[crossed.at][0], CROSS[crossed.at][1]) : (a > b ? t('Added to cart', 'تمت الإضافة إلى السلة') : t('Cart updated', 'تم تحديث السلة'));
    var sub = next ? t('Add <b>' + money(next.at - a) + '</b> to get ' + next.en, 'أضف <b>' + money(next.at - a) + '</b> لتحصل على ' + next.ar) : t('You unlocked every offer', 'حصلت على جميع العروض');
    var last = GOALS[GOALS.length - 1].at, w = Math.min(100, a / last * 100);
    if (!toastEl) {
      toastEl = document.createElement('div'); toastEl.className = 'eq-toast'; toastEl.dir = AR ? 'rtl' : 'ltr';
      toastEl.addEventListener('click', function () { location.href = '/cart'; });
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<p class="eq-toast__t">' + icon(crossed ? 'ok' : (next ? next.icon : 'ok')) + '<span>' + title + '</span></p><p class="eq-toast__s">' + sub + '</p><div class="eq-toast__bar"><i style="width:' + w + '%"></i></div>';
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(hideT); hideT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 6000);
  }
  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { if (userChange && prev !== null && c.items_subtotal_price !== prev && !document.querySelector('#cart-drawer dialog[open]') && !/\/cart$/.test(location.pathname)) toast(prev, c.items_subtotal_price); userChange = false; prev = c.items_subtotal_price; subtotal = c.items_subtotal_price; render(); checkoutBtn(); }).catch(function () {});
    }, 150);
  }
  // re-fetch after any cart change made by the theme
  var of = window.fetch;
  window.fetch = function (u) {
    var p = of.apply(this, arguments);
    try { var url = typeof u === 'string' ? u : (u && u.url) || ''; if (/\/cart\/(add|change|update|clear)/.test(url)) { userChange = true; p.then(refresh, refresh); } } catch (e) {}
    return p;
  };
  new MutationObserver(function () { if (subtotal !== null) { render(); checkoutBtn(); } if (!document.querySelector('.eq-offer')) offerBox(); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart:update', refresh);
  refresh();

  // product page offer box
  function offerBox() {
    if (!/^product/.test((document.querySelector('#MainContent') || {}).dataset ? document.querySelector('#MainContent').dataset.template || '' : '')) return;
    var form = document.querySelector('#MainContent form[action*="/cart/add"]');
    if (!form || document.querySelector('.eq-offer')) return;
    var rows = [
      ['cod', t('<b>EGP 500+</b> pay cash on delivery', '<b>من 500 جنيه:</b> الدفع عند الاستلام')],
      ['ship', t('<b>EGP 3,000+</b> free shipping', '<b>من 3000 جنيه:</b> شحن مجاني')],
      ['pct', t('<b>EGP 4,000+</b> 10% off + free shipping', '<b>من 4000 جنيه:</b> خصم 10% وشحن مجاني')],
      ['pct', t('<b>EGP 8,000+</b> 15% off + free shipping', '<b>من 8000 جنيه:</b> خصم 15% وشحن مجاني')]
    ];
    var el = document.createElement('div');
    el.className = 'eq-offer'; el.dir = AR ? 'rtl' : 'ltr';
    el.innerHTML = '<div class="eq-offer__head">' + t('Buy more, <span>save more</span>', 'اطلب أكثر <span>ووفّر أكثر</span>') + '</div>' +
      rows.map(function (r) { return '<div class="eq-offer__row">' + icon(r[0]) + '<span>' + r[1] + '</span></div>'; }).join('');
    var anchor = form.closest('product-form-component') || form;
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', offerBox); else offerBox();
})();
